/**
 * This is a wrapper component for different Layouts.
 * Navigational 'aside' content should be added to this wrapper.
 */
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../util/reactIntl';
import { withViewport } from '../../util/contextHelpers';
import { LayoutWrapperSideNav } from '../../components';
import { ensureCurrentUser } from '../../util/data';

const LayoutWrapperAccountSettingsSideNavComponent = props => {
  const { currentTab, currentUser = null } = props;

  const user = ensureCurrentUser(currentUser);
  // const isOfferEnabled = !!user.attributes.profile.metadata.decathlon_user || !!user.attributes.profile.metadata.is_provider;
  const isOfferEnabled = true;
  const paymentsTab = isOfferEnabled ? [{
    text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentsTabTitle" />,
    selected: currentTab === 'StripePayoutPage',
    id: 'StripePayoutPageTab',
    linkProps: {
      name: 'StripePayoutSettingsPage',
    }}] : []

  const tabs = [
    ...paymentsTab,
  ];

  return <LayoutWrapperSideNav tabs={tabs} />;
};

const LayoutWrapperAccountSettingsSideNav = compose(
  connect((state) => {
    return {
      currentUser: state.user.currentUser
    }
  }),
  withViewport
)(
  LayoutWrapperAccountSettingsSideNavComponent
);

export default LayoutWrapperAccountSettingsSideNav;
